import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useProducts } from '../ProductContext'; // Correct for src/ProductContext.js

const Beats = () => {
  console.log('Rendering Beats');
  const { popular, latest } = useProducts();
  console.log('Popular:', popular, 'Latest:', latest);
  const navigate = useNavigate();

  const handleCardClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <div className="bg-black text-center justify-center p-2 text-gray-400">
      <h1>Beats Component</h1>
      <div className="text-xm">
        <p>Number One Best Selling Music NFT Platform WORLDWIDE</p>
        <p>Music NFT Sales</p>
        <p>Beat NFT Sales</p>
        <p>Blockchain Music/Beat Auctioning</p>
      </div>
      <div className="mt-4">
        <h1 className="font-bold font-serif text-xl text-yellow-300">OUR POPULAR COLLECTIONS</h1>
        <div className="mt-2 p-2 z-10 grid grid-cols-2 gap-5 md:grid-cols-3 md:gap-10 md:pl-16 md:justify-evenly">
          {popular.map((product) => (
            <div
              key={product.id}
              className="rounded shadow shadow-green-600 sm:w-48 bg-gray-600 relative cursor-pointer"
              onClick={() => handleCardClick(product.id)}
            >
              <img src={product.image} alt={product.title} className="w-full h-32 sm:h-48 object-cover" />
              <div className="justify-between font-semibold text-white">
                <p className="uppercase">{product.artist}</p>
                <p>{product.title}</p>
              </div>
              <audio controls className="h-10 w-full p-2">
                <source src={product.audio} />
              </audio>
              <div className="p-2">
                <Link to={product.status === 'sold' ? '/Sold' : '/Buy'} onClick={(e) => e.stopPropagation()}>
                  <button
                    className={`font-bold rounded-lg text-black px-4 p-2 ${
                      product.status === 'sold' ? 'bg-orange-600' : 'bg-green-600'
                    }`}
                  >
                    {product.status === 'sold' ? 'SOLD' : 'BUY'}
                  </button>
                </Link>
              </div>
              <div className="absolute top-0 bg-white rounded-lg p-1 m-4 font-bold">
                <span>${product.price}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="text-white p-10 z-10 justify-center text-center">
        <h1 className="text-xl font-serif oldstyle-nums text-yellow-300 my-10 font-bold">LATEST COLLECTIONS</h1>
        <div className="justify-items-center justify-center text-center pt-2 grid gap-5 md:grid md:gap-10 md:px-40 lg:px-33">
          {latest.map((product) => (
            <div
              key={product.id}
              className="rounded shadow-white shadow bg-black overflow-hidden cursor-pointer"
              onClick={() => handleCardClick(product.id)}
            >
              <video controls>
                <source src={product.video} />
              </video>
              <div className="flex font-bold justify-between m-2 text-black">
                <p className="p-2 rounded-lg bg-gray-600">{product.artist}</p>
                <p className="p-2 rounded-lg bg-gray-600">{product.title}</p>
                <p className="p-2 rounded-lg bg-red-600">${product.price}</p>
              </div>
              <Link to={product.status === 'sold' ? '/Sold' : '/Buy'} onClick={(e) => e.stopPropagation()}>
                <button
                  className={`font-bold rounded-lg text-black px-4 p-2 mb-2 ${
                    product.status === 'sold' ? 'bg-orange-600' : 'bg-green-600'
                  }`}
                >
                  {product.status === 'sold' ? 'SOLD' : 'BUY'}
                </button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Beats;